export const movies = [
  {
    id: "m001",
    title: "星际回声",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险", "剧情"],
    director: "艾伦·沃德",
    cast: ["杰克·雷恩", "索菲亚·卡尔", "丹尼尔·福特"],
    language: "英语",
    duration: "148 分钟",
    releaseDate: "2024-11-08",
    rating: 8.6,
    hot: 98,
    featured: true,
    summary: "一支深空探测队在遥远星系捕获到神秘回声，人类的起源之谜随之被揭开。",
    description:
      "在不远的未来，人类首次向猎户座边缘发射载人探测船“回声号”。当飞船捕获到一段规律出现的低频信号时，领航员艾拉发现这段信号竟与地球早期文明的音乐结构完全吻合。随着调查深入，团队必须在返航与继续追寻之间做出抉择，而每一个答案都将重新定义人类在宇宙中的位置。影片以沉稳的叙事与震撼的视效，探讨了孤独、信仰与探索的永恒主题。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20art%20with%20a%20lone%20astronaut%20silhouette%20floating%20before%20a%20vast%20glowing%20nebula%20and%20a%20distant%20ringed%20planet%2C%20deep%20blue%20tones%20with%20warm%20orange%20rim%20lighting%2C%20dramatic%20moody%20atmosphere%2C%20highly%20detailed%20key%20art%20against%20a%20clean%20dark%20neutral%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-01&orientation=portrait",
  },
  {
    id: "m002",
    title: "暗夜追缉",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["犯罪", "惊悚", "动作"],
    director: "马库斯·格雷",
    cast: ["伊森·布莱克", "克洛伊·亚当斯", "雷·莫里斯"],
    language: "英语",
    duration: "126 分钟",
    releaseDate: "2023-09-22",
    rating: 8.1,
    hot: 92,
    featured: true,
    summary: "一名坚持原则的老警探在雨夜追踪连环案件，真相却指向他最信任的人。",
    description:
      "底特律的连绵雨季里，警探哈里斯被指派调查一系列看似毫无关联的抢劫案。随着线索逐渐交汇，他发现所有案件都指向警局内部的一个秘密网络。在信任与职责之间，哈里斯必须独自完成这场孤独的追缉。影片以凌厉的剪辑和压抑的雨夜氛围，呈现一部硬核犯罪题材作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20thriller%20movie%20poster%20art%20with%20a%20lone%20detective%20standing%20under%20heavy%20rain%20in%20a%20dark%20city%20alley%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20high%20contrast%20shadows%20and%20warm%20amber%20highlights%2C%20cinematic%20moody%20composition%2C%20detailed%20key%20art%20on%20a%20clean%20dark%20neutral%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-02&orientation=portrait",
  },
  {
    id: "m003",
    title: "王冠与灰烬",
    type: "tv",
    year: 2024,
    region: "英国",
    genres: ["剧情", "历史", "战争"],
    director: "伊莎贝尔·哈特",
    cast: ["艾米莉·肖", "托马斯·里德", "凯瑟琳·韦恩"],
    language: "英语",
    duration: "共 3 季 / 单集约 55 分钟",
    releaseDate: "2024-04-19",
    rating: 8.9,
    hot: 90,
    featured: true,
    summary: "在动荡年代，一位年轻的王位继承人在权谋与信仰之间挣扎前行。",
    description:
      "故事设定在一个虚构的欧洲王国，年轻的继承人阿黛拉在父王骤然离世后被迫登上王位。面对邻国的觊觎、宫廷的背叛与民众的期待，她必须在理想与现实之间寻找平衡。剧集以精良的时代质感与细腻的人物刻画，讲述权力背后的孤独与代价。",
    cover:
      "https://readdy.ai/api/search-image?query=Period%20drama%20television%20poster%20art%20featuring%20a%20regal%20figure%20in%20a%20dark%20velvet%20cloak%20standing%20in%20a%20candlelit%20stone%20hall%2C%20golden%20crown%20and%20warm%20ember%20glow%2C%20rich%20shadows%2C%20elegant%20cinematic%20composition%20with%20deep%20contrast%2C%20detailed%20key%20art%20on%20a%20clean%20dark%20neutral%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-03&orientation=portrait",
  },
  {
    id: "m004",
    title: "沉默航班",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["惊悚", "悬疑"],
    director: "内森·科尔",
    cast: ["奥利维亚·格兰特", "迈克尔·陈", "莎拉·布莱克"],
    language: "英语",
    duration: "112 分钟",
    releaseDate: "2024-07-12",
    rating: 7.7,
    hot: 85,
    featured: true,
    summary: "一架跨洋航班在万米高空失去联络，乘客们发现真正的威胁来自机舱之内。",
    description:
      "跨洋航班 517 号在进入巡航高度后与地面失去联系。空乘莉娜逐渐意识到，机上的种种异样并非机械故障那么简单。在密闭而高压的空间里，她必须拼凑出真相，并在一切无法挽回之前阻止更大的灾难。影片全程高能，营造出令人窒息的密闭悬疑感。",
    cover:
      "https://readdy.ai/api/search-image?query=Suspenseful%20thriller%20movie%20poster%20art%20with%20an%20airplane%20window%20overlooking%20storm%20clouds%20at%20night%2C%20a%20tense%20silhouette%20of%20a%20passenger%2C%20cold%20steel%20and%20amber%20lighting%2C%20claustrophobic%20cinematic%20mood%2C%20high%20contrast%2C%20detailed%20key%20art%20on%20a%20clean%20dark%20neutral%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-04&orientation=portrait",
  },
  {
    id: "m005",
    title: "北境迷雾",
    type: "tv",
    year: 2023,
    region: "英国",
    genres: ["悬疑", "犯罪", "剧情"],
    director: "艾登·摩尔",
    cast: ["汉娜·里德", "詹姆斯·凯勒", "露西·班克罗夫特"],
    language: "英语",
    duration: "共 2 季 / 单集约 50 分钟",
    releaseDate: "2023-10-05",
    rating: 8.4,
    hot: 88,
    featured: true,
    summary: "苏格兰高地的雾夜里接连发生失踪案，一位女警探揭开了小镇尘封的秘密。",
    description:
      "在常年被雾气笼罩的北方小镇，警探凯特回到故乡调查一系列离奇失踪。随着调查推进，她发现每一个消失的人都与二十年前的一桩旧案有关，而小镇的每个人都在隐瞒着什么。剧集以冷峻的色调与缓慢推进的悬疑节奏，构建出极具张力的北方社区群像。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20series%20poster%20art%20showing%20a%20misty%20Scottish%20highland%20landscape%20at%20dusk%20with%20a%20distant%20lone%20figure%20and%20a%20small%20stone%20town%2C%20cool%20grey%20tones%20with%20a%20single%20warm%20window%20light%2C%20moody%20cinematic%20composition%2C%20detailed%20key%20art%20on%20a%20clean%20dark%20neutral%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-05&orientation=portrait",
  },
  {
    id: "m006",
    title: "纽约二十四小时",
    type: "movie",
    year: 2022,
    region: "美国",
    genres: ["剧情", "动作"],
    director: "瑞秋·桑德斯",
    cast: ["大卫·诺兰", "阿米拉·哈桑", "卢卡斯·贝尔"],
    language: "英语",
    duration: "134 分钟",
    releaseDate: "2022-08-26",
    rating: 7.5,
    hot: 70,
    summary: "一名急诊医生与一名出租车司机，在一天之内被卷进同一场城市风暴。",
    description:
      "曼哈顿的二十四小时里，急诊医生 Maya 和出租车司机 Danny 的人生因为一场突发事件交织在一起。影片以多线并行的结构与快速切换的城市节奏，描绘大都市中普通人的坚韧与善意，展现了都市生活里那些微小却重要的连接。",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20movie%20poster%20art%20depicting%20a%20busy%20New%20York%20city%20street%20at%20blue%20hour%20with%20tall%20buildings%20and%20moving%20taxi%20lights%2C%20a%20solitary%20figure%20walking%20through%20the%20crowd%2C%20cinematic%20blur%20and%20warm%20highlights%2C%20moody%20composition%2C%20detailed%20key%20art%20on%20a%20clean%20dark%20neutral%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-06&orientation=portrait",
  },
  {
    id: "m007",
    title: "机械之心",
    type: "movie",
    year: 2025,
    region: "美国",
    genres: ["科幻", "剧情"],
    director: "维克多·兰姆",
    cast: ["诺亚·斯特林", "艾拉·贝克", "乔治·庞德"],
    language: "英语",
    duration: "139 分钟",
    releaseDate: "2025-03-14",
    rating: 8.3,
    hot: 95,
    summary: "当一名工程师为纪念亡妻造出会思考的机器人，关于“心”的定义被彻底改写。",
    description:
      "工程师马丁在妻子离世后，把她生前的记忆与语言习惯写入一台人形机器人“薇拉”。随着薇拉学会自主思考，马丁开始面对一个艰难的伦理问题：被复制的爱是否仍然是爱。影片以克制的科幻表达与温柔的情感内核，探讨科技与人性的边界。",
    cover:
      "https://readdy.ai/api/search-image?query=Emotional%20science%20fiction%20movie%20poster%20art%20with%20a%20humanoid%20robot%20touching%20a%20glowing%20mechanical%20heart%2C%20soft%20teal%20and%20warm%20amber%20lighting%2C%20clean%20futuristic%20studio%20background%20with%20subtle%20bokeh%2C%20cinematic%20and%20tender%20mood%2C%20highly%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark%2C%20no%20logo&width=400&height=600&seq=mv-cover-07&orientation=portrait",
  },
  {
    id: "m008",
    title: "巴黎的雨天",
    type: "movie",
    year: 2023,
    region: "法国",
    genres: ["爱情", "剧情"],
    director: "克莱尔·杜邦",
    cast: ["艾玛·洛朗", "卢卡·莫雷", "席琳·贝赫"],
    language: "法语",
    duration: "108 分钟",
    releaseDate: "2023-05-19",
    rating: 7.9,
    hot: 66,
    summary: "一场突如其来的雨，让两个陌生人在巴黎的旧书店里停留了整个下午。",
    description:
      "在塞纳河畔的一家旧书店里，作家保罗与花店店主艾琳因为一场大雨相识。他们聊文学、聊遗憾、聊那些未曾说出口的告白。影片以细腻的对话与柔和的光影，讲述一段始于雨天、终于成长的城市爱情故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20French%20drama%20movie%20poster%20art%20with%20an%20old%20Parisian%20bookstore%20storefront%20in%20the%20rain%2C%20warm%20lamplight%20spilling%20onto%20wet%20cobblestones%2C%20two%20distant%20figures%20sharing%20an%20umbrella%2C%20soft%20pastel%20tones%2C%20cinematic%20tender%20mood%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-08&orientation=portrait",
  },
  {
    id: "m009",
    title: "荒原猎手",
    type: "tv",
    year: 2024,
    region: "加拿大",
    genres: ["冒险", "动作", "惊悚"],
    director: "格雷戈里·林",
    cast: ["卡尔·门罗", "娜拉·塞维斯", "伊桑·沃尔特"],
    language: "英语",
    duration: "共 1 季 / 单集约 48 分钟",
    releaseDate: "2024-02-02",
    rating: 7.6,
    hot: 74,
    summary: "在极北荒原，一名向导带领队伍穿越无人区，却卷入了更大的生存博弈。",
    description:
      "经验丰富的荒野向导科尔接到一份高报酬任务：带一队科研人员穿越北极圈内的无人区。随着补给耗尽与环境恶化，队伍内部的矛盾逐渐激化，科尔必须在极寒与人性之间找到生路。剧集以壮阔的自然景观与紧张的生存叙事，呈现一场关于勇气与信任的考验。",
    cover:
      "https://readdy.ai/api/search-image?query=Rugged%20adventure%20series%20poster%20art%20with%20a%20lone%20hunter%20standing%20in%20a%20deep%20snowy%20wilderness%20under%20a%20pale%20northern%20sky%2C%20distant%20pine%20forest%20and%20cold%20mist%2C%20cool%20icy%20tones%20with%20a%20warm%20orange%20jacket%20accent%2C%20cinematic%20epic%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-09&orientation=portrait",
  },
  {
    id: "m010",
    title: "最后的信号",
    type: "movie",
    year: 2024,
    region: "英国",
    genres: ["科幻", "悬疑"],
    director: "菲奥娜·里德",
    cast: ["亚历克斯·哈特", "米娅·科尔曼", "山姆·里维斯"],
    language: "英语",
    duration: "121 分钟",
    releaseDate: "2024-09-27",
    rating: 8.0,
    hot: 82,
    summary: "一座废弃的射电天文台，突然收到了来自四十年前自己的回复。",
    description:
      "物理学家 Grace 回到一座即将拆除的射电天文台整理旧资料，却意外收到一段来自四十年前、署名她自己的信号。随着解码深入，她意识到这不仅仅是一次时间上的异常，更是一个关于选择与悔恨的谜题。影片以安静而克制的氛围，构建了一个精巧的时间悬疑故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20science%20fiction%20mystery%20movie%20poster%20art%20with%20a%20huge%20abandoned%20radio%20telescope%20dish%20silhouetted%20against%20a%20starry%20twilight%20sky%2C%20a%20small%20figure%20holding%20a%20lantern%2C%20cool%20indigo%20tones%20with%20warm%20amber%20glow%2C%20cinematic%20moody%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-10&orientation=portrait",
  },
  {
    id: "m011",
    title: "午夜喜剧俱乐部",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["喜剧", "剧情"],
    director: "贝弗莉·斯通",
    cast: ["吉米·瓦伦", "萝拉·芬奇", "奥马尔·阿齐兹"],
    language: "英语",
    duration: "共 3 季 / 单集约 30 分钟",
    releaseDate: "2023-06-10",
    rating: 7.8,
    hot: 64,
    summary: "一家濒临倒闭的深夜喜剧俱乐部，成了几位落魄演员重新出发的舞台。",
    description:
      "在洛杉矶的一条旧街上，喜剧俱乐部“午夜”只剩最后三个月的租期。老板吉米召集了一群各有心事的脱口秀演员，试图用一场场演出挽救这里。剧集以温暖幽默的笔触，讲述一群平凡人在失败中互相扶持、重新找回热爱的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20comedy%20drama%20series%20poster%20art%20with%20a%20retro%20comedy%20club%20stage%20spotlight%2C%20a%20microphone%20stand%20and%20a%20sign%20glowing%20at%20midnight%2C%20rich%20amber%20and%20deep%20burgundy%20tones%2C%20soft%20lens%20flare%2C%20cinematic%20nostalgic%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-11&orientation=portrait",
  },
  {
    id: "m012",
    title: "柏林密码",
    type: "movie",
    year: 2022,
    region: "德国",
    genres: ["惊悚", "悬疑", "犯罪"],
    director: "汉斯·贝格",
    cast: ["莱娜·克劳斯", "马丁·霍夫", "安娜·舒尔茨"],
    language: "德语",
    duration: "118 分钟",
    releaseDate: "2022-11-11",
    rating: 7.4,
    hot: 60,
    summary: "一名密码学专家被卷入冷战遗留的密文谜局，解开它意味着暴露真相。",
    description:
      "密码学专家尤莉娅在整理父亲遗物时，发现一组从未被破译的密文。随着她逐步解码，一段被尘封的冷战往事浮出水面，而某些人并不希望真相被公开。影片节奏紧凑、悬念层层递进，是一部极具质感的欧洲惊悚片。",
    cover:
      "https://readdy.ai/api/search-image?query=European%20spy%20thriller%20movie%20poster%20art%20with%20a%20tense%20figure%20walking%20through%20a%20rainy%20Berlin%20street%20at%20night%2C%20old%20lampposts%20and%20cold%20concrete%20architecture%2C%20muted%20grey%20tones%20with%20a%20single%20warm%20amber%20light%2C%20cinematic%20moody%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-12&orientation=portrait",
  },
  {
    id: "m013",
    title: "深海之城",
    type: "movie",
    year: 2025,
    region: "美国",
    genres: ["奇幻", "冒险"],
    director: "伊莲娜·沃兹",
    cast: ["凯拉·摩根", "瑞恩·卡特", "小林·沃特"],
    language: "英语",
    duration: "142 分钟",
    releaseDate: "2025-06-20",
    rating: 8.2,
    hot: 91,
    summary: "少女潜入深海，寻找传说中被洋流守护的失落之城。",
    description:
      "为了寻找失踪的海洋生物学家母亲，少女奈拉独自驾驶微型潜艇潜入深海。她循着发光生物与古老洋流，抵达了一座被传说包围的失落之城。影片以绚丽的深海奇观与童话般的叙事，讲述勇气、亲情与守护海洋的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%20art%20showing%20a%20young%20diver%20descending%20toward%20a%20glowing%20lost%20underwater%20city%20with%20towers%20and%20coral%2C%20bioluminescent%20teal%20and%20gold%20light%2C%20magical%20cinematic%20atmosphere%2C%20highly%20detailed%20key%20art%20on%20a%20dark%20deep%20blue%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-13&orientation=portrait",
  },
  {
    id: "m014",
    title: "洛城警事",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["犯罪", "剧情"],
    director: "保罗·门德斯",
    cast: ["丹尼·沃克", "艾丽莎·摩尔", "布莱恩·雷"],
    language: "英语",
    duration: "共 4 季 / 单集约 45 分钟",
    releaseDate: "2024-01-15",
    rating: 8.1,
    hot: 80,
    summary: "洛城警局的一支重案组，在每一起案件背后直面城市的复杂与温情。",
    description:
      "洛杉矶警局重案组的日常，是在纷繁的案发现场与复杂的人际关系中寻找真相。剧集通过单元案件与人物主线的交织，展现了一线警探的职业信念与生活压力，也描绘了这座城市光鲜背后的另一面。",
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20drama%20series%20poster%20art%20with%20a%20group%20of%20detectives%20silhouetted%20near%20a%20police%20car%20at%20dusk%20in%20Los%20Angeles%2C%20palm%20trees%20and%20warm%20sunset%20haze%2C%20deep%20contrast%20between%20shadow%20and%20orange%20light%2C%20cinematic%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-14&orientation=portrait",
  },
  {
    id: "m015",
    title: "曼彻斯特往事",
    type: "movie",
    year: 2021,
    region: "英国",
    genres: ["剧情", "爱情"],
    director: "莎拉·霍尔",
    cast: ["汤姆·艾略特", "露西·哈珀", "本·卡特"],
    language: "英语",
    duration: "115 分钟",
    releaseDate: "2021-10-08",
    rating: 7.7,
    hot: 55,
    summary: "多年之后回到北方老城的男人，重新面对那段没能说出口的旧情。",
    description:
      "阔别家乡十五年的建筑师汤姆因父亲的葬礼回到曼彻斯特。在整理旧宅的过程中，他与年轻时的恋人露西重逢。影片以缓慢而克制的叙事，讲述时间如何改变一个人，也如何保留一个人心底最柔软的部分。",
    cover:
      "https://readdy.ai/api/search-image?query=Melancholic%20British%20drama%20movie%20poster%20art%20with%20a%20row%20of%20old%20terraced%20houses%20in%20northern%20England%20under%20a%20soft%20grey%20sky%2C%20a%20lone%20figure%20standing%20at%20a%20window%2C%20muted%20cool%20tones%20with%20a%20single%20warm%20lamp%2C%20cinematic%20quiet%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-15&orientation=portrait",
  },
  {
    id: "m016",
    title: "罗马假日重映",
    type: "movie",
    year: 2023,
    region: "意大利",
    genres: ["爱情", "喜剧"],
    director: "马泰奥·里奇",
    cast: ["吉亚·罗西", "卢卡·费拉", "艾琳娜·孔蒂"],
    language: "意大利语",
    duration: "104 分钟",
    releaseDate: "2023-04-21",
    rating: 7.6,
    hot: 58,
    summary: "一位导游与一位临时“逃班”的女演员，在罗马度过了一整天的意外假期。",
    description:
      "罗马街头，导游马可偶然遇见了想要暂时逃离工作的女演员吉亚。两人决定用一个下午假装成普通游客，游览这座古老城市。影片以轻松明快的节奏与浪漫的意式风情，讲述一段短暂的相遇如何治愈长久的疲惫。",
    cover:
      "https://readdy.ai/api/search-image?query=Sunny%20Italian%20romantic%20comedy%20movie%20poster%20art%20with%20a%20classic%20Roman%20street%20and%20a%20vintage%20scooter%20beside%20warm%20terracotta%20buildings%2C%20golden%20afternoon%20light%20and%20soft%20shadows%2C%20two%20cheerful%20figures%20in%20the%20distance%2C%20cinematic%20warm%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-16&orientation=portrait",
  },
  {
    id: "m017",
    title: "战争余烬",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["战争", "剧情"],
    director: "安德鲁·派恩",
    cast: ["马克·哈里森", "索菲·莱恩", "杰森·库珀"],
    language: "英语",
    duration: "152 分钟",
    releaseDate: "2024-05-30",
    rating: 8.5,
    hot: 87,
    summary: "战争结束多年后，一位老兵重返旧地，寻找当年救过他的那户人家。",
    description:
      "退役老兵詹姆斯在战争结束二十年后，带着一封未能寄出的信回到当年的欧洲小镇。他想找到曾在战火中收留他的那户人家，完成一个迟到的感谢。影片以沉静而有力的影像，展现战争留下的创伤与人性中不灭的善意。",
    cover:
      "https://readdy.ai/api/search-image?query=Somber%20war%20drama%20movie%20poster%20art%20with%20an%20aging%20veteran%20standing%20in%20a%20quiet%20European%20field%20at%20dawn%2C%20distant%20ruined%20village%20and%20low%20mist%2C%20muted%20earthy%20tones%20with%20a%20warm%20golden%20horizon%2C%20cinematic%20melancholic%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-17&orientation=portrait",
  },
  {
    id: "m018",
    title: "银河商队",
    type: "tv",
    year: 2025,
    region: "美国",
    genres: ["科幻", "喜剧", "冒险"],
    director: "蒂娜·奥尔特加",
    cast: ["卡洛斯·维加", "娜奥米·普莱斯", "迪恩·黑尔"],
    language: "英语",
    duration: "共 2 季 / 单集约 40 分钟",
    releaseDate: "2025-01-24",
    rating: 7.9,
    hot: 78,
    summary: "一群落魄的星际小贩，驾驶破旧货船在银河边缘接单求生。",
    description:
      "在银河系的边缘地带，船长佐伊和她的船员们开着一艘随时会散架的货船，接下各种稀奇古怪的运输委托。剧集以轻松幽默的方式，讲述一群“不靠谱”的人在宇宙里努力生活的冒险故事，笑点与温情并存。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20space%20comedy%20series%20poster%20art%20with%20a%20ragged%20little%20cargo%20spaceship%20flying%20past%20a%20colorful%20alien%20planet%20and%20ring%20system%2C%20vibrant%20teal%20and%20orange%20nebula%2C%20quirky%20cinematic%20composition%2C%20highly%20detailed%20key%20art%20on%20a%20clean%20dark%20background%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-18&orientation=portrait",
  },
  {
    id: "m019",
    title: "悉尼风暴",
    type: "movie",
    year: 2023,
    region: "澳大利亚",
    genres: ["动作", "惊悚"],
    director: "杰克·奥斯本",
    cast: ["欧文·哈里斯", "卡拉·布朗", "李奥·沃德"],
    language: "英语",
    duration: "124 分钟",
    releaseDate: "2023-12-01",
    rating: 7.3,
    hot: 62,
    summary: "一场百年不遇的风暴夜，救援队长必须在城市断电前完成最后一场营救。",
    description:
      "超强风暴逼近悉尼，城市电力系统濒临瘫痪。海岸救援队长欧文接到最后一个求救信号——一艘被困在港湾外的游轮。在狂风巨浪与时间赛跑的过程中，他必须做出可能改变许多人命运的决定。影片节奏紧凑，动作场面震撼。",
    cover:
      "https://readdy.ai/api/search-image?query=High%20octane%20action%20movie%20poster%20art%20with%20a%20storm%20towering%20over%20a%20coastal%20city%20skyline%20at%20night%2C%20huge%20waves%20and%20lightning%2C%20a%20rescue%20boat%20silhouette%2C%20dark%20steel%20blue%20tones%20with%20warm%20amber%20emergency%20light%2C%20cinematic%20dramatic%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-19&orientation=portrait",
  },
  {
    id: "m020",
    title: "西班牙之月",
    type: "movie",
    year: 2024,
    region: "西班牙",
    genres: ["剧情", "爱情"],
    director: "艾莲娜·加西亚",
    cast: ["帕布罗·桑切斯", "卢西亚·罗梅罗", "丹尼尔·维拉"],
    language: "西班牙语",
    duration: "110 分钟",
    releaseDate: "2024-08-16",
    rating: 7.8,
    hot: 61,
    summary: "一位画家在南方小镇度过夏天，遇见了一段改变他创作与人生的感情。",
    description:
      "画家帕布罗为寻找灵感来到安达卢西亚的一座白色小镇。在这里，他遇见了当地的花艺师卢西亚，并在她的陪伴下重新找回了对色彩的感知。影片以浓郁的南欧风情与温暖的光影，讲述一段关于创作、爱与自我和解的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20Spanish%20romantic%20drama%20movie%20poster%20art%20with%20a%20whitewashed%20Andalusian%20village%20at%20sunset%2C%20terracotta%20rooftops%20and%20bougainvillea%2C%20a%20painter%20figure%20on%20a%20rooftop%2C%20golden%20orange%20light%20and%20soft%20shadows%2C%20cinematic%20warm%20composition%2C%20detailed%20key%20art%2C%20no%20text%2C%20no%20watermark&width=400&height=600&seq=mv-cover-20&orientation=portrait",
  },
];